import React, { useState } from "react";
import ClassNames from "classnames";
import ActionsMenu from "../ActionsMenu/ActionsMenu.js";
import IconButton from "../../controls/Buttons/IconButton/IconButton.js";
import type { ActionsMenuItem } from "../ActionsMenu/ActionsMenu";

export interface SidebarTitleActionsProps {
  actions: ActionsMenuItem[];
  "data-testid": string;
}

const SidebarTitleActions: React.FC<SidebarTitleActionsProps> = ({
  actions,
  "data-testid": dataTestId,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <ActionsMenu
      className="sidebar-title-actions-menu"
      triggerClassName="sidebar-title-actions"
      data-testid={`${dataTestId}-title-actions`}
      menuItems={actions}
      onMenuOpenChange={setIsOpen}
      place="bottom-start"
    >
      <IconButton
        isIcon="seem-icon-more-actions"
        className={ClassNames("sidebar-title-actions-trigger", {
          active: isOpen,
        })}
        data-testid={`${dataTestId}-title-actions-trigger`}
      />
    </ActionsMenu>
  );
};

export default SidebarTitleActions;
